module.exports = __webpack_public_path__ + "static/media/brand20.6b8a2356.png";